'use strict';

var moment = require('moment-timezone');
var commonTimeHelper = {
  getCurrentTimeStamp: function getCurrentTimeStamp(application) {
    application = !application.settings ? application.toJSON() : application;
    var d = new Date();
    if (application.settings.timezone_offset) {
      // log('adding eq.application.settings.timezone_offset: ' + req.application.settings.timezone_offset )
      var time = d.getTime() + application.settings.timezone_offset * 1000;
      if (application.settings.timezone_dst) {
        if (this.isDST(application)) {
          var t = new Date(time);
          time += Number(application.settings.timezone_dst) * 1000;
          var t = new Date(time);
        }
      }
      d = new Date(time);
    }
    return d;
  },
  // [Deprecated] Use getTimezoneProper instead.
  getTimeZone: function getTimeZone(application) {
    return this.getTimezoneProper(application.settings.timezone);
  },
  getTimezoneProper: function getTimezoneProper(timezone) {
    switch (timezone) {
      case 'Hawaii':
        timezone = 'Pacific/Honolulu';
        break;
      case 'Alaska':
        timezone = 'America/Anchorage';
        break;
      case 'Pacific Time (US &amp; Canada)':
      case 'Pacific Time (US & Canada)':
        timezone = 'America/Los_Angeles';
        break;
      case 'Arizona':
        timezone = 'America/Phoenix';
        break;
      case 'Mountain Time (US &amp; Canada)':
      case 'Mountain Time (US & Canada)':
        timezone = 'America/Boise';
        break;
      case 'Central Time (US &amp; Canada)':
      case 'Central Time (US & Canada)':
        timezone = 'America/Chicago';
        break;
      case 'Eastern Time (US &amp; Canada)':
      case 'Eastern Time (US & Canada)':
        timezone = 'America/New_York';
        break;
      case 'Indiana (East)':
        timezone = 'America/Indianapolis';
        break;
      case 'Midway Island':
        timezone = 'Pacific/Midway';
        break;
      case 'Samoa':
        timezone = 'Pacific/Samoa';
        break;
      case 'Tijuana':
        timezone = 'America/Tijuana';
        break;
      case 'Chihuahua':
        timezone = 'America/Chihuahua';
        break;
      case 'Mazatlan':
        timezone = 'America/Mazatlan';
        break;
      case 'Central America':
        timezone = 'America/Managua';
        break;
      case 'Guadalajara':
        timezone = 'America/Mexico_City';
        break;
      case 'Mexico City':
        timezone = 'America/Mexico_City';
        break;
      case 'Monterrey':
        timezone = 'America/Monterrey';
        break;
      case 'Saskatchewan':
        timezone = 'America/Edmonton';
        break;
      case 'Bogota':
        timezone = 'America/Bogota';
        break;
      case 'Lima':
        timezone = 'America/Lima';
        break;
      case 'Quito':
        timezone = 'America/Guayaquil';
        break;
      case 'Caracas':
        timezone = 'America/Caracas';
        break;
      case 'Atlantic Time (Canada)': // deprecated, to be removed from UI, but may still exist in schema
      case 'Halifax':
        timezone = 'America/Halifax';
        break;
      case 'La Paz':
        timezone = 'America/La_Paz';
        break;
      case 'Santiago':
        timezone = 'America/Santiago';
        break;
      case 'Newfoundland':
        timezone = 'America/St_Johns';
        break;
      case 'Brasilia': // deprecated, to be removed from UI, but may still exist in schema
      case 'Sao Paulo':
        timezone = 'America/Sao_Paulo';
        break;
      case 'Buenos Aires':
        timezone = 'America/Argentina/Buenos_Aires';
        break;
      case 'Georgetown': // deprecated, to be removed from UI, but may still exist in schema
      case 'Georgetown (Guyana)':
        timezone = 'America/Guyana';
        break;
      case 'Greenland':
        timezone = 'America/Godthab';
        break;
      case 'Mid-Atlantic':
        timezone = 'America/Moncton';
        break;
      case 'Azores':
        timezone = 'Atlantic/Azores';
        break;
      case 'Cape Verde Is.':
        timezone = 'Atlantic/Cape_Verde';
        break;
      case 'Casablanca':
        timezone = 'Africa/Casablanca';
        break;
      case 'Dublin':
        timezone = 'Europe/Dublin';
        break;
      case 'Edinburgh':
        timezone = 'Europe/Dublin';
        break;
      case 'Lisbon':
        timezone = 'Europe/Lisbon';
        break;
      case 'London':
        timezone = 'Europe/London';
        break;
      case 'Monrovia':
        timezone = 'Africa/Monrovia';
        break;
      case 'Amsterdam':
        timezone = 'Europe/Amsterdam';
        break;
      case 'Belgrade':
        timezone = 'Europe/Belgrade';
        break;
      case 'Berlin':
        timezone = 'Europe/Berlin';
        break;
      case 'Bern':
        timezone = 'Europe/Berlin';
        break;
      case 'Bratislava':
        timezone = 'Europe/Bratislava';
        break;
      case 'Brussels':
        timezone = 'Europe/Brussels';
        break;
      case 'Budapest':
        timezone = 'Europe/Budapest';
        break;
      case 'Copenhagen':
        timezone = 'Europe/Copenhagen';
        break;
      case 'Ljubljana':
        timezone = 'Europe/Ljubljana';
        break;
      case 'Madrid':
        timezone = 'Europe/Madrid';
        break;
      case 'Paris':
        timezone = 'Europe/Paris';
        break;
      case 'Prague':
        timezone = 'Europe/Prague';
        break;
      case 'Rome':
        timezone = 'Europe/Rome';
        break;
      case 'Sarajevo':
        timezone = 'Europe/Sarajevo';
        break;
      case 'Skopje':
        timezone = 'Europe/Skopje';
        break;
      case 'Stockholm':
        timezone = 'Europe/Stockholm';
        break;
      case 'Vienna':
        timezone = 'Europe/Vienna';
        break;
      case 'Warsaw':
        timezone = 'Europe/Warsaw';
        break;
      case 'West Central Africa':
        timezone = 'Africa/Lagos';
        break;
      case 'Zagreb':
        timezone = 'Europe/Zagreb';
        break;
      case 'Athens':
        timezone = 'Europe/Athens';
        break;
      case 'Bucharest':
        timezone = 'Europe/Bucharest';
        break;
      case 'Cairo':
        timezone = 'Africa/Cairo';
        break;
      case 'Harare':
        timezone = 'Africa/Harare';
        break;
      case 'Helsinki':
        timezone = 'Europe/Helsinki';
        break;
      case 'Istanbul':
        timezone = 'Asia/Istanbul';
        break;
      case 'Jerusalem':
        timezone = 'Asia/Jerusalem';
        break;
      case 'Kyiv':
        timezone = 'Europe/Kiev';
        break;
      case 'Pretoria':
        timezone = 'Africa/Johannesburg';
        break;
      case 'Riga':
        timezone = 'Europe/Riga';
        break;
      case 'Sofia':
        timezone = 'Europe/Sofia';
        break;
      case 'Tallinn':
        timezone = 'Europe/Tallinn';
        break;
      case 'Vilnius':
        timezone = 'Europe/Vilnius';
        break;
      case 'Baghdad':
        timezone = 'Asia/Baghdad';
        break;
      case 'Kuwait':
        timezone = 'Asia/Kuwait';
        break;
      case 'Minsk':
        timezone = 'Europe/Minsk';
        break;
      case 'Nairobi':
        timezone = 'Africa/Nairobi';
        break;
      case 'Riyadh':
        timezone = 'Asia/Riyadh';
        break;
      case 'Tehran':
        timezone = 'Asia/Tehran';
        break;
      case 'Abu Dhabi':
        timezone = 'Asia/Dubai';
        break;
      case 'Baku':
        timezone = 'Asia/Baku';
        break;
      case 'Moscow':
        timezone = 'Europe/Moscow';
        break;
      case 'Muscat':
        timezone = 'Asia/Muscat';
        break;
      case 'St. Petersburg':
        timezone = 'Europe/Moscow';
        break;
      case 'Tbilisi':
        timezone = 'Asia/Tbilisi';
        break;
      case 'Volgograd':
        timezone = 'Europe/Volgograd';
        break;
      case 'Yerevan':
        timezone = 'Asia/Yerevan';
        break;
      case 'Kabul':
        timezone = 'Asia/Kabul';
        break;
      case 'Islamabad':
        timezone = 'Asia/Karachi';
        break;
      case 'Karachi':
        timezone = 'Asia/Karachi';
        break;
      case 'Tashkent':
        timezone = 'Asia/Tashkent';
        break;
      case 'Chennai':
        timezone = 'Asia/Kolkata';
        break;
      case 'Kolkata':
        timezone = 'Asia/Kolkata';
        break;
      case 'Mumbai':
        timezone = 'Asia/Kolkata';
        break;
      case 'New Delhi':
        timezone = 'Asia/Kolkata';
        break;
      case 'Kathmandu':
        timezone = 'Asia/Kathmandu';
        break;
      case 'Almaty':
        timezone = 'Asia/Almaty';
        break;
      case 'Astana':
        timezone = 'Asia/Omsk';
        break;
      case 'Dhaka':
        timezone = 'Asia/Dhaka';
        break;
      case 'Ekaterinburg':
        timezone = 'Asia/Aqtobe';
        break;
      case 'Sri Jayawardenepura':
        timezone = 'Asia/Kolkata';
        break;
      case 'Rangoon':
        timezone = 'Asia/Rangoon';
        break;
      case 'Bangkok':
        timezone = 'Asia/Bangkok';
        break;
      case 'Hanoi':
        timezone = 'Asia/Saigon';
        break;
      case 'Jakarta':
        timezone = 'Asia/Jakarta';
        break;
      case 'Novosibirsk':
        timezone = 'Asia/Novosibirsk';
        break;
      case 'Beijing':
        timezone = 'Asia/Shanghai';
        break;
      case 'Chongqing':
        timezone = 'Asia/Chongqing';
        break;
      case 'Hong Kong':
        timezone = 'Asia/Hong_Kong';
        break;
      case 'Krasnoyarsk':
        timezone = 'Asia/Krasnoyarsk';
        break;
      case 'Kuala Lumpur':
        timezone = 'Asia/Kuala_Lumpur';
        break;
      case 'Perth':
        timezone = 'Australia/Perth';
        break;
      case 'Singapore':
        timezone = 'Asia/Singapore';
        break;
      case 'Taipei':
        timezone = 'Asia/Taipei';
        break;
      case 'Ulaan Bataar': // deprecated, to be removed from UI, but may still exist in schema
      case 'Ulaanbataar':
        timezone = 'Asia/Ulaanbaatar';
        break;
      case 'Urumqi':
        timezone = 'Asia/Urumqi';
        break;
      case 'Irkutsk':
        timezone = 'Asia/Irkutsk';
        break;
      case 'Osaka':
        timezone = 'Asia/Tokyo';
        break;
      case 'Sapporo':
        timezone = 'Asia/Tokyo';
        break;
      case 'Seoul':
        timezone = 'Asia/Seoul';
        break;
      case 'Tokyo':
        timezone = 'Asia/Tokyo';
        break;
      case 'Adelaide':
        timezone = 'Australia/Adelaide';
        break;
      case 'Darwin':
        timezone = 'Australia/Darwin';
        break;
      case 'Brisbane':
        timezone = 'Australia/Brisbane';
        break;
      case 'Canberra':
        timezone = 'Australia/Canberra';
        break;
      case 'Guam':
        timezone = 'Pacific/Guam';
        break;
      case 'Hobart':
        timezone = 'Australia/Hobart';
        break;
      case 'Melbourne':
        timezone = 'Australia/Melbourne';
        break;
      case 'Port Moresby':
        timezone = 'Pacific/Port_Moresby';
        break;
      case 'Sydney':
        timezone = 'Australia/Sydney';
        break;
      case 'Yakutsk':
        timezone = 'Asia/Yakutsk';
        break;
      case 'New Caledonia':
        timezone = 'Pacific/Noumea';
        break;
      case 'Solomon Is.':
        timezone = 'Pacific/Guadalcanal';
        break;
      case 'Vladivostok':
        timezone = 'Asia/Vladivostok';
        break;
      case 'Auckland':
        timezone = 'Pacific/Auckland';
        break;
      case 'Fiji':
        timezone = 'Pacific/Fiji';
        break;
      case 'Kamchatka':
        timezone = 'Asia/Kamchatka';
        break;
      case 'Magadan':
        timezone = 'Asia/Magadan';
        break;
      case 'Marshall Is.':
        timezone = 'Pacific/Majuro';
        break;
      case 'Wellington':
        timezone = 'Pacific/Auckland';
        break;
      case 'Nuku\'alofa':
        timezone = 'Pacific/Tongatapu';
        break;
    }
    return timezone;
  },
  // return if today is DST
  isDST: function isDST(application, check_date) {
    if (!application) {
      return false;
    }

    // application.toJSON call is used when time-helper is called on the client, where
    // application is a backbone model, and calling toJSON makes application.settings
    // available in the following getTimeZone call
    application = !application.settings ? application.toJSON() : application;
    var timezone = this.getTimeZone(application);
    if (!check_date) {
      check_date = new Date();
    }
    var time = moment(check_date).tz(timezone);
    return time ? time.isDST() : false;
  }
};
module.exports = commonTimeHelper;